import React from 'react';
import { Box } from '@hover/blueprint';
import PricingTableDesktop from './DesktopTable';
import PricingTableTablet from './TabletTable';

const PricingTable: React.FC = () => (
  <Box w="100%" flexDir="column" bg="brandTan.100" position="relative">
    <Box
      id="choose-plan-best-fits-your-team"
      position="absolute"
      w={0}
      h={0}
      top="-130px"
    />
    <PricingTableDesktop />
    <PricingTableTablet />
  </Box>
);

export default PricingTable;
